import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import {
  FacebookLoginButton,
  GoogleLoginButton,
  AppleLoginButton,
} from "react-social-login-buttons";

import "./index.css";
import { AuthContext } from "../../../contexts/AuthContext";

const SignIn = (props) => {
  const navigate = useNavigate();
  const { logIn } = useContext(AuthContext);

  const signInWithGoogle = async () => {
    const userAgent = navigator.userAgent;
  
    if (userAgent.indexOf("Instagram") !== -1) {
      alert("Please open in your system browser to continue.");
      return;
    } else if (userAgent.indexOf("LinkedIn") !== -1) {
      alert("Please open in your system browser to continue.");
      return;
    } else if (userAgent.indexOf("Facebook") !== -1) {
      alert("Please open in your system browser to continue.");
      return;
    }
  
    await logIn("google");
    navigate("/");
  };

  const signInWithFacebook = async () => {
    await logIn("facebook");
    navigate("/");
  };
  const signInWithApple = async () => {
    await logIn("apple");
    navigate("/");
  };

  return (
    <div className="sign-in">
      <div className="bg-wrapper">
        <h1>Reach your fitness goals with an AI-enabled coach</h1>
        <div className="value-props">
          <div className="prop">
            <i className="fa fa-check" />Track food by describing it
          </div>
          <div className="prop">
            <i className="fa fa-check" />Create personalized meal plans
          </div>
          <div className="prop">
            <i className="fa fa-check" />Generate exercise routines
          </div>
        </div>
        <div className="sign-in-container">
          <div className="sign-in-error-wrapper">
            <p className="error-msg"></p>
          </div>
          <div className="sign-in-buttons">
            <GoogleLoginButton className="social-button google" onClick={signInWithGoogle}>
              Sign in with Google
            </GoogleLoginButton>
          {/*
           <FacebookLoginButton className="social-button fb" onClick={signInWithFacebook}>
              Sign in with Facebook
            </FacebookLoginButton>
            <AppleLoginButton onClick={signInWithApple}>
              Sign in with Apple
            </AppleLoginButton> 
          */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignIn;
